import React from "react";

export const NoomEmailAddressLink = (
  <a href="mailto:partnersupport@noom.com">partnersupport@noom.com</a>
);
